import React from 'react';
import { UndoOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { OTTO_PDF_UNDO_MESSAGE, OTTO_PDF_RESTORE_MESSAGE } from '../common/pdf/PDFDesigner/PDFDesigner.constants';

function OttoPDFChatHeaderActions({
  onUndo,
  onRestore,
  canUndo,
  addMessage,
}) {
  return (
    <>
      {onUndo && (
        <UndoOutlined
          className="otto-chat-action-icon"
          onClick={() => {
            if (canUndo) {
              const success = onUndo();
              if (success) {
                addMessage(OTTO_PDF_UNDO_MESSAGE);
              }
            }
          }}
          style={{
            cursor: canUndo ? 'pointer' : 'not-allowed',
            opacity: canUndo ? 1 : 0.4,
            marginRight: '8px',
          }}
          title={canUndo ? 'Undo last change' : 'No changes to undo'}
          disabled={!canUndo}
        />
      )}
      {onRestore && (
        <button
          type="button"
          onClick={() => {
            addMessage(OTTO_PDF_RESTORE_MESSAGE);
            onRestore();
          }}
          style={{
            padding: '4px 8px',
            fontSize: '12px',
            backgroundColor: '#f0f0f0',
            border: '1px solid #ccc',
            borderRadius: '4px',
            cursor: 'pointer',
            marginRight: '8px',
            color: '#333',
          }}
          title="Restore to original layout"
        >
          Restore
        </button>
      )}
    </>
  );
}

OttoPDFChatHeaderActions.propTypes = {
  onUndo: PropTypes.func,
  onRestore: PropTypes.func,
  canUndo: PropTypes.bool,
  addMessage: PropTypes.func.isRequired,
};

export default OttoPDFChatHeaderActions;
